import { InitialState, ActionConstant, ActionType } from './types';

// Reducer
const initialState: InitialState = {
	isMessage: false,
	messageType: '',
	messageContent: {},
	beforeSend: false,
};

export function clearToast(): ActionType {
	return { type: ActionConstant.CLEAR_ALL };
}

export function errorHandling(errorData: any = {}): ActionType {
	const { response = {} } = errorData;
	const { data = {}, status = 0 } = response;
	const { message = '', error = [] } = data;
	let validation = {};

	if (status === 422) {
		validation = Object.keys(error).map((e) => {
			const { message = '', key = '' } = error[e];
			return { key, message };
		});
	}

	if (status === 400) {
		validation = { 0: { key: '', message } };
	}

	return {
		type: ActionConstant.GET_TOAST,
		isMessage: true,
		messageType: 'Error',
		messageContent: validation,
	};
}

export function errorHandlings(errorData: any = {}): ActionType {
	const { message = '' } = errorData;
	const validation = { 0: { key: '', message } };

	return {
		type: ActionConstant.GET_TOAST,
		isMessage: true,
		messageType: 'Error',
		messageContent: validation,
	};
}

export function inputValidation(errorData: any = {}): ActionType {
	if (errorData.length === 0) {
		return { type: ActionConstant.CLEAR_ALL };
	}
	const validation = errorData.map((e: any) => {
		const { message = '', key = '' } = e;
		return { key, message };
	});

	return {
		type: ActionConstant.GET_TOAST,
		isMessage: true,
		messageType: 'Error',
		messageContent: validation,
	};
}
export function showMessage(message: any = {}): ActionType {
	const { isMessage = false, messageType = '', messageContent = {} } = message;
	return {
		type: ActionConstant.GET_TOAST,
		isMessage,
		messageType,
		messageContent,
	};
}

export function beforeSend(): ActionType {
	return { type: ActionConstant.BEFORE_SEND };
}

export function afterSend(): ActionType {
	return { type: ActionConstant.AFTER_SEND };
}

function toastReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_TOAST: {
			return {
				...state,
				isMessage: action.isMessage,
				messageType: action.messageType,
				messageContent: action.messageContent,
				beforeSend: false,
			};
		}
		case ActionConstant.CLEAR_ALL:
			return {
				...state,
				isMessage: false,
				messageType: '',
				messageContent: {},
				beforeSend: false,
			};
		case ActionConstant.BEFORE_SEND:
			return {
				...state,
				beforeSend: true,
			};
		case ActionConstant.AFTER_SEND:
			return {
				...state,
				beforeSend: false,
			};
		default:
			return state;
	}
}

export default toastReducer;
